import { Popover, Grid, TextField, MenuItem, Button, Typography, Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import CachedIcon from '@mui/icons-material/Cached';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import MaskedInput from 'components/Utils/MaskedInput';
import useFiltrosTabelaDetalhesHook from '../../hooks/useFiltrosTabelaDetalhesHook';
import './FiltrosTabelaDetalhes.scss';

export default function FiltrosTabelaDetalhes({ onFiltrar, contadorFiltros, presetFiltros }) {
  const {
    filtros,
    open,
    id,
    anchorEl,
    handleChange,
    handleOpen,
    handleClose,
    handleLimpar,
    handleFiltrar,
    listaTipoOperacao,
    listaTipoDocumento,
    validaSeDataInicialMaiorQueFinal
  } = useFiltrosTabelaDetalhesHook({ onFiltrar, presetFiltros });

  const validaSedataInicioMaiorQueFinal = validaSeDataInicialMaiorQueFinal(
    filtros.venc_de,
    filtros.venc_ate
  );

  return (
    <>
      <Box className="box-filtros-btn">
        <Button
          aria-describedby={id}
          className="btn-filtros-cessao detalhes"
          variant="outlined"
          onClick={handleOpen}
        >
          <Box className="filtros-titulo">
            <FilterListIcon />
            {contadorFiltros > 0 && <Box className="contador-filtros">{contadorFiltros}</Box>} FILTROS
          </Box>
        </Button>

        <Button
          id="limpar-filtros"
          className="btn-filtros-cessao detalhes"
          variant="outlined"
          onClick={handleLimpar}
        >
          <Box className="filtros-titulo">
            <CachedIcon />
            LIMPAR
          </Box>
        </Button>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="componente-filtros"
        PaperProps={{ className: 'componente-filtros__paper' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          popper: {
            modifiers: [
              { name: 'flip', enabled: false },
              { name: 'offset', options: { offset: [0, 8] } },
              { name: 'preventOverflow', options: { tether: false } }
            ]
          }
        }}
      >
        <Box className="filtros-card">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Nome do cedente"
                  fullWidth
                  value={filtros.nome_cedente}
                  onChange={e => handleChange('nome_cedente', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <MaskedInput
                  label="CPF/CNPJ do cedente"
                  fullWidth
                  name="cpfcnpj_cedente"
                  value={filtros.cpfcnpj_cedente ?? ''}
                  onChange={e => handleChange('cpfcnpj_cedente', e.target.value)}
                  getFormat="cpfCnpj"
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Nome do sacado"
                  fullWidth
                  value={filtros.nome_sacado}
                  onChange={e => handleChange('nome_sacado', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <MaskedInput
                  label="CPF/CNPJ do sacado"
                  fullWidth
                  name="cpfcnpj_sacado"
                  value={filtros.cpfcnpj_sacado ?? ''}
                  onChange={e => handleChange('cpfcnpj_sacado', e.target.value)}
                  getFormat="cpfCnpj"
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Tipo de operação"
                  select
                  fullWidth
                  value={filtros.tipo_operacao}
                  onChange={e => handleChange('tipo_operacao', e.target.value)}
                >
                  <MenuItem value="">Selecione</MenuItem>
                  {listaTipoOperacao.map(tipoOpe => (
                    <MenuItem key={tipoOpe.CODPRODUTO} value={tipoOpe.CODPRODUTO}>
                      {tipoOpe.NOME} &nbsp; <small>{tipoOpe.SIGLA}</small>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Tipo de documento"
                  select
                  fullWidth
                  value={filtros.tipo_documento}
                  onChange={e => handleChange('tipo_documento', e.target.value)}
                >
                  <MenuItem value="">Selecione</MenuItem>
                  {listaTipoDocumento.map(tipoDoc => (
                    <MenuItem key={tipoDoc.CODTDOC} value={tipoDoc.CODTDOC}>
                      {tipoDoc.CODTDOC}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Número do documento"
                  fullWidth
                  value={filtros.numero_documento}
                  onChange={e => handleChange('numero_documento', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Borderô"
                  fullWidth
                  value={filtros.bordero}
                  onChange={e => handleChange('bordero', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Typography className="label-data">Data de aceite</Typography>
                <DatePicker
                  label="Início"
                  className="w-100"
                  value={filtros.data_aceite_de}
                  onChange={newVal => handleChange('data_aceite_de', newVal)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <DatePicker
                  label="Fim"
                  className="ajuste-input-label w-100"
                  value={filtros.data_aceite_ate}
                  onChange={newVal => handleChange('data_aceite_ate', newVal)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Typography className="label-data">Data de vencimento</Typography>

                <DatePicker
                  label="Início"
                  className="w-100"
                  value={filtros.venc_de}
                  onChange={newVal => handleChange('venc_de', newVal)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <DatePicker
                  label="Fim"
                  className="ajuste-input-label w-100"
                  value={filtros.venc_ate}
                  onChange={newVal => handleChange('venc_ate', newVal)}
                  slotProps={{
                    textField: {
                      error: validaSedataInicioMaiorQueFinal,
                      helperText: validaSedataInicioMaiorQueFinal
                        ? 'A data final não pode ser menor que a inicial.'
                        : ''
                    }
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

          <Box className="filtros-footer">
            <Typography className="filtros-footer-text">
              Você pode aplicar novos filtros sem perder a seleção anterior
            </Typography>
            <Button
              variant="outlined"
              onClick={handleFiltrar}
              disabled={validaSedataInicioMaiorQueFinal}
            >
              Filtrar
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
